import PropTypes from 'prop-types';

const CallSubComment = ({ data }) => (
  <>
    <span className="non-capitalized">{data.message}</span>
    <span>
      By: {data.createdByFirstName} {data.createdByLastName}
    </span>
  </>
);

CallSubComment.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CallSubComment;
